module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-craft-32-active.8c61b999.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-craft-32-active.png
// module id = 3192
// module chunks = 11